import { Button, Group, Image, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import VpLogoSrc from '@/assets/vp-stripes.png'
import { LicenseProduct } from '@/types/subscription'
import { formatPrice } from '@/utils/price'

type LicenseInfoProps = {
  licenseName: string
  price: number
  currency: string
  billingPeriod: LicenseProduct['billing_period']
  onUpgrade: () => void
}

export const LicenseInfo = ({
  licenseName,
  price,
  currency,
  billingPeriod,
  onUpgrade
}: LicenseInfoProps) => {
  return (
    <Group align="center" justify="space-between">
      <Group wrap="nowrap" align="start">
        <Image src={VpLogoSrc} h={32} w="auto" />

        <Stack gap={4}>
          <Text>{licenseName}</Text>

          <Text fw={600}>
            <FormattedMessage
              id={
                billingPeriod === 'monthly'
                  ? 'subscriptions.pricePerMonth'
                  : 'subscriptions.pricePerYear'
              }
              values={{
                price: formatPrice(price, currency)
              }}
            />
          </Text>
        </Stack>
      </Group>

      <Button size="xs" onClick={onUpgrade}>
        <FormattedMessage id="subscriptions.upgradeLicense" />
      </Button>
    </Group>
  )
}
